import { ArrowDown } from "lucide-react";
import type { LandingConfig } from "@/types/site-config";
import { ParagraphText } from "@/components/text/paragraph-text";

export function LandingHero({ config }: { config: LandingConfig }) {
  return (
    <section
      id="landing"
      className="relative w-full overflow-hidden"
      style={{ height: `${config.heightVh}vh` }}
    >
      <img
        src={config.imageSrc}
        alt={config.imageAlt}
        fetchPriority="high"
        className="absolute inset-0 h-full w-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-black/82 via-black/38 to-black/18" />
      <div className="relative z-10 flex h-full items-end px-4 pb-10 pt-24 sm:px-8 lg:px-14 bg-gradient-to-t from-black/60 via-black/20 to-black/0">
        <div className="max-w-3xl backdrop-brightness-50 rounded-md bg-black/40 p-6 sm:p-10 responsive-text">
          <p className="text-sm uppercase tracking-[0.22em] text-amber-200">manifesto</p>
          <h1 className="mt-4 text-4xl font-semibold leading-tight sm:text-6xl">
            {config.headline}
          </h1>
          <ParagraphText className="mt-5 max-w-2xl text-base leading-7 text-stone-100/86 sm:text-lg" text={config.manifesto} paragraphClassName="mb-4" />
          <a
            href={config.primaryActionHref}
            className="mt-7 inline-flex items-center gap-2 rounded-md bg-red-500 px-4 py-3 text-sm font-semibold text-white transition hover:bg-red-400"
          >
            {config.primaryActionLabel}
            <ArrowDown className="h-4 w-4" aria-hidden />
          </a>
        </div>
      </div>
    </section>
  );
}
